function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { string, oneOf, bool, func, element, oneOfType } from 'prop-types';
import Button from '../../Button';
import classNames from 'classnames';
import { TriangleDownIcon } from '@ruter-ds/rds-icons';
var propTypes = {
  /** The component will generate an id for you.<br>
   * If you need to create your own, pass it in as a prop */
  id: string.isRequired,

  /** Button text */
  text: string.isRequired,

  /** Choose between these variants: */
  variant: oneOf(['filled', 'outline', 'flat']),

  /** Choose between these skins: */
  skin: oneOf(['dark', 'light', 'success', 'danger', 'info']),

  /** Choose between these sizes: */
  size: oneOf(['small', 'medium', 'large']),

  /** Choose between these shapes: */
  shape: oneOf(['rounded', 'pill']),

  /** @deprecated Use `isFluid` instead */
  fluid: bool,

  /** Makes the button fill the parents available space */
  isFluid: bool,

  /** Make the button disabled */
  disabled: bool,

  /** Place icon before text.*/
  iconLeft: element,

  /** Place custom icon before text. */
  customIconLeft: string,

  /** Hides the text visually. Still available for screen readers */
  hideText: bool,

  /** Sets `aria-expanded="true|false"` on button */
  expanded: bool,

  /** Callback function for toggle on the button */
  onClick: func,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  expanded: false,
  variant: 'filled'
};
/** The visible button that toggles the Dropdown Menu.
 * @visibleName Dropdown Toggle
 * */

var DropdownToggle = /*#__PURE__*/function (_Component) {
  _inherits(DropdownToggle, _Component);

  var _super = _createSuper(DropdownToggle);

  function DropdownToggle() {
    _classCallCheck(this, DropdownToggle);

    return _super.apply(this, arguments);
  }

  _createClass(DropdownToggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          variant = _this$props.variant,
          skin = _this$props.skin,
          size = _this$props.size,
          shape = _this$props.shape,
          fluid = _this$props.fluid,
          isFluid = _this$props.isFluid,
          disabled = _this$props.disabled,
          iconLeft = _this$props.iconLeft,
          customIconLeft = _this$props.customIconLeft,
          hideText = _this$props.hideText,
          expanded = _this$props.expanded,
          onClick = _this$props.onClick,
          className = _this$props.className;
      var componentClassNames = classNames('rds-dropdown__toggle', {
        'rds-is-expanded': expanded
      }, className);
      return /*#__PURE__*/React.createElement(Button, {
        className: componentClassNames,
        text: text,
        id: id,
        skin: skin,
        size: size,
        shape: shape,
        fluid: fluid,
        isFluid: isFluid,
        disabled: disabled,
        hideText: hideText,
        element: "button",
        variant: variant,
        iconLeft: iconLeft,
        iconRight: /*#__PURE__*/React.createElement(TriangleDownIcon, null),
        customIconLeft: customIconLeft,
        onClick: onClick,
        "aria-haspopup": "true",
        "aria-expanded": expanded
      });
    }
  }]);

  return DropdownToggle;
}(Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
export default DropdownToggle;